// from https://github.com/waterthetrees/wtt_front/blob/ca79409298f40547721b63b14fdbbd3ca953c96b/client/src/pages/Map/MapboxControlPortal.js
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';

const ControlTranslated = ({ map, position, children }) => {
    const [container, setContainer] = useState(null);

    const instanceRef = useRef({
        onAdd() {
          const div = document.createElement('div');
    
          div.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
          setContainer(div);
    
          return div;
    },

    onRemove() {
        setContainer((container) => {
          if (container) {
            container.parentNode.removeChild(container);
          }
          return null;
        });
      },
    });

    useEffect(() => {
        if (map && !container) {
          map.addControl(instanceRef.current, position);
        }
        return () => {
          if (map && container) {
            map.remove(container);
          }
        };
    }, [map]);

    return container
    ? ReactDOM.createPortal(
      children,
      container,
    )
    : null;
}

export default ControlTranslated;